import React from "react";
import AddProducts from "../AddProduct/AddProducts";
import AvailableProducts from "../AvailableProducts/AvailableProducts";

const Home = () => {
  return (
    <>
      <main className="py-16">
        <div className="productWrapper">
          <AvailableProducts></AvailableProducts>
          <AddProducts></AddProducts>
        </div>
      </main>
    </>
  );
};

export default Home;
